import { Col, Row } from "antd";
import Typography from "../../../components/Typography";
import Image from "next/image";
import { SectionContainer } from "../styled";
import Products from "./products.json";
import {
  ImageContainer,
  ProductsButton,
  ProductsContainer,
  ProductsContent,
} from "./styled";
import Link from "next/link";
import { useRouter } from "next/router";

export default function ProductsAndServices() {
  const router = useRouter();
  return (
    <ProductsContainer>
      <SectionContainer pScale={1.5}>
        <Typography
          fontFamily="Lora"
          fontWeight="bold"
          textAlign="center"
          fontSize="2rem"
          color="darkGray2"
          margin={[0, 0, 30, 0]}
        >
          Our Products & Services
        </Typography>
        <Row gutter={32}>
          {Products.map((product) => (
            <Col xs={24} md={8} key={product.id}>
              <ImageContainer>
                <Link href={product.link}>
                  <a>
                    <Image alt="Product or Service" {...product.image} />
                  </a>
                </Link>
              </ImageContainer>

              <Typography
                color="darkGray2"
                fontWeight="bold"
                textAlign="center"
                fontSize="1.4rem"
              >
                {product.title}
              </Typography>
              <Typography textAlign="center" fontWeight="600">
                {product.description}
              </Typography>
            </Col>
          ))}
        </Row>
        <ProductsButton
          ptype="primaryVariant"
          bRadius={"0px"}
          ptop="20px"
          pbottom={"20px"}
          pleft="40px"
          pright="40px"
          height="50px"
          onClick={() => router.push("/view-all-products")}
        >
          ALL CLASSY PRODUCTS
        </ProductsButton>
      </SectionContainer>
    </ProductsContainer>
  );
}
